import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Homeroom' },
    { value: 2, label: 'Course' },
    { value: 3, label: 'Class' },
    { value: 4, label: 'Group' },
    { value: 5, label: 'Shared' },
    { value: 6, label: 'Auto' },
  ],
});
